import { Phone, Mail } from "lucide-react";
import { BUSINESS } from "@/lib/data";
import { useLang } from "@/lib/LangContext";

export default function StickyContactBar() {
  const { lang } = useLang();

  return (
    <div
      data-testid="sticky-contact-bar"
      className="fixed bottom-0 inset-x-0 z-40 border-t border-primary/40 bg-[hsl(0_0%_5%)]/95 backdrop-blur-md"
      style={{ paddingBottom: "env(safe-area-inset-bottom, 0px)" }}
    >
      <div className="mx-auto max-w-[1600px] grid grid-cols-2">
        <a
          href={BUSINESS.phoneHref}
          data-testid="sticky-phone"
          className="group flex items-center justify-center gap-3 py-3 md:py-4 border-r border-border/60 hover:bg-primary transition-colors"
        >
          <Phone
            size={16}
            strokeWidth={1.6}
            className="text-primary group-hover:text-white transition-colors"
          />
          <div className="text-left">
            <div className="font-mono text-[9px] tracking-[0.25em] uppercase text-muted-foreground group-hover:text-white/80 transition-colors leading-none">
              {lang === "fr" ? "Répartition" : "Dispatch"}
            </div>
            <div className="font-serif text-sm md:text-base leading-tight group-hover:text-white transition-colors">
              {BUSINESS.phone}
            </div>
          </div>
        </a>
        <a
          href={BUSINESS.emailHref}
          data-testid="sticky-email"
          className="group flex items-center justify-center gap-3 py-3 md:py-4 hover:bg-primary transition-colors"
        >
          <Mail
            size={16}
            strokeWidth={1.6}
            className="text-primary group-hover:text-white transition-colors"
          />
          <div className="text-left overflow-hidden">
            <div className="font-mono text-[9px] tracking-[0.25em] uppercase text-muted-foreground group-hover:text-white/80 transition-colors leading-none">
              {lang === "fr" ? "Courriel" : "Email"}
            </div>
            <div className="font-serif text-sm md:text-base leading-tight group-hover:text-white transition-colors truncate">
              {BUSINESS.email}
            </div>
          </div>
        </a>
      </div>
    </div>
  );
}
